module.exports = __webpack_public_path__ + "static/media/CHARTERS TOWERS REGIONAL.8de804e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/CHARTERS TOWERS REGIONAL.svg
// module id = 534
// module chunks = 0